import React, { useEffect, useState } from "react";
import axios from "axios";
import { Icon } from "@iconify/react";
import DropDown from "../../../bookings/Shared_components/DropDown";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CampaignPic from "../../../../assets/images/message.jpg";
import CampaignPic2 from "../../../../assets/images/campaign2.jpg";
import CampaignPic3 from "../../../../assets/images/Campaign3.jpg";
import "./Quotation.css";

import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { redirectToIdentityLogin } from "../../../../utils/identityLogin";
import {
  validatePostCode,
  validateAndFormatPostCode,
  validateAndFormatPostCodeFromWeb,
} from "../../../../utils/postCodeValidation";
import MangoBookingModal from "../../../bookings/components/MangoBookingModal/MangoBookingModal";
import {
  PRICING_DRAFT_KEY,
  buildMangoProducDetails,
  fetchMangoTransitionCost,
  markMangoShipmentReady,
  mergeReceiverIntoDraft,
  readMangoPricingDraft,
  saveMangoTransitCost,
  summarizeTransitCostResults,
} from "../../../../utils/mangoBookingFlow";
import { isMangoFeatureEnabled } from "../../../../utils/featureFlags";

const Quotation = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const mangoFeatureEnabled = isMangoFeatureEnabled();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [routes, setRoutes] = useState([]);
  const [measurementUnits, setMeasurementUnits] = useState([]);
  const [itemCategories, setItemCategories] = useState([]);
  const [weights, setWeights] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  const [fruitsWeights, setFruitsWeights] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedWeightData, setSelectedWeightData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [quotationData, setQuotationData] = useState(null);
  const [isMangoPricing, setIsMangoPricing] = useState(false);
  const [activeTab, setActiveTab] = useState("regular");
  const [formData, setFormData] = useState({
    routeId: "",
    measurementUnitId: "",
    fromPostCode: "",
    toPostCode: "",
    weight: "",
    length: "",
    width: "",
    height: "",
  });
  const [mangoFormData, setMangoFormData] = useState({
    routeId: "",
    weightId: "",
    toPostCode: "",
    qty: "1",
  });
  const [mangoPostCodeError, setMangoPostCodeError] = useState("");
  const [mangoBookingModalOpen, setMangoBookingModalOpen] = useState(false);
  const [mangoBookingSubmitting, setMangoBookingSubmitting] = useState(false);
  const [mangoBookingFormData, setMangoBookingFormData] = useState({
    country: [],
    city: [],
  });
  const [mangoReceiver, setMangoReceiver] = useState({
    receiverName: "",
    receiverEmail: "",
    receiverMobileNumber: "",
    receiverCountry: "",
    receiverLandmark: "",
    receiverCity: "",
    receiverDoorNo: "",
    receiverStreetName: "",
    receiverRemarks: "",
    receiverAddress: "",
    receiverPostCode: "",
    additionalInfo: "",
  });

  const slides = [
    {
      id: 1,
      image: CampaignPic,
      title: "Join now to save upto 45% savings on your deliveries.",
    },
    {
      id: 2,
      image: CampaignPic2,
      title: "Fast, reliable deliveries at unbeatable prices.",
    },
    {
      id: 3,
      image: CampaignPic3,
      title: "Limited-time offers you don’t want to miss.",
    },
  ];

  useEffect(() => {
    if (mangoFeatureEnabled) return;

    if (activeTab === "mango") {
      setActiveTab("regular");
    }

    if (mangoBookingModalOpen) {
      setMangoBookingModalOpen(false);
    }

    if (searchParams.get("openMangoBooking") === "1") {
      setSearchParams({}, { replace: true });
    }
  }, [
    activeTab,
    mangoBookingModalOpen,
    mangoFeatureEnabled,
    searchParams,
    setSearchParams,
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  // Fetch routes and measurement units on component mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    // Fetch routes
    axios
      .get(`${backendUrl}Route`, { headers })
      .then((res) => {
        setRoutes(res.data || []);
      })
      .catch((err) => {
        console.log("Error fetching routes:", err.message);
      });

    // Fetch measurement units
    axios
      .get(`${backendUrl}MeasurementUnit`, { headers })
      .then((res) => {
        setMeasurementUnits(res.data || []);
      })
      .catch((err) => {
        console.log("Error fetching measurement units:", err.message);
      });

    // Fetch item categories
    axios
      .get(`${backendUrl}ItemCategory`, { headers })
      .then((res) => {
        setItemCategories(res.data || []);
        // Find Fruits category ID
        const fruitsCategory = res.data?.find(
          (cat) => cat.name === "Fruits" || cat.id === 19,
        );
        if (fruitsCategory) {
          // Fetch weights filtered by Fruits category
          axios
            .get(`${backendUrl}Weight`, { headers })
            .then((weightRes) => {
              const allWeights = weightRes.data || [];
              // Filter weights where itemCategoryId matches Fruits
              const fruitsWeightsList = allWeights.filter(
                (weight) => weight.itemCategoryId === fruitsCategory.id,
              );
              setFruitsWeights(fruitsWeightsList);
              setWeights(allWeights);
            })
            .catch((err) => {
              console.log("Error fetching weights:", err.message);
            });
        }
      })
      .catch((err) => {
        console.log("Error fetching item categories:", err.message);
      });

    // Fetch dimensions
    axios
      .get(`${backendUrl}Dimension`, { headers })
      .then((res) => {
        setDimensions(res.data || []);
      })
      .catch((err) => {
        console.log("Error fetching dimensions:", err.message);
      });

    // Fetch countries
    axios
      .get(`${backendUrl}Country`, { headers })
      .then((res) => {
        setCountries(res.data || []);
        // Preselect UK (id 22) for mango pricing
        const ukCountry = res.data?.find((country) => country.id === 22);
        if (ukCountry && routes.length > 0) {
          // Find a route that matches UK or preselect first UK-related route
          // For now, we'll just set a default route if available
          // The route selection will be handled when mango tab is active
        }
      })
      .catch((err) => {
        console.log("Error fetching countries:", err.message);
      });

    // Fetch countries
    axios
      .get(`${backendUrl}Country`, { headers })
      .then((res) => {
        setCountries(res.data || []);
        // Preselect UK (id 22) for mango pricing
        const ukCountry = res.data?.find((country) => country.id === 22);
        if (ukCountry && routes.length > 0) {
          // Find a route that matches UK or preselect first UK-related route
          // For now, we'll just set a default route if available
          // The route selection will be handled when mango tab is active
        }
      })
      .catch((err) => {
        console.log("Error fetching countries:", err.message);
      });
  }, [backendUrl]);

  // Preselect UK route (id 22) when mango tab is active
  useEffect(() => {
    if (activeTab === "mango" && routes.length > 0 && !mangoFormData.routeId) {
      // Directly find route with id 22 (UK - UK)
      const ukRoute = routes.find((route) => route.id === 22);

      if (ukRoute) {
        setMangoFormData((prev) => ({
          ...prev,
          routeId: String(ukRoute.id),
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, routes]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleMangoInputChange = (field, value) => {
    // If route changes, clear weightId if current weight doesn't match new route
    if (field === "routeId" && value) {
      const currentWeightId = mangoFormData.weightId;
      if (currentWeightId) {
        const currentWeight = fruitsWeights.find(
          (w) => w.id === parseInt(currentWeightId),
        );
        // If current weight's route doesn't match new route, clear weight selection
        if (currentWeight && currentWeight.routeId !== parseInt(value)) {
          setMangoFormData((prev) => ({
            ...prev,
            routeId: value,
            weightId: "", // Clear weight when route changes
          }));
          setSelectedWeightData(null);
          return;
        }
      }
    }

    if (field === "qty") {
      setMangoFormData((prev) => ({ ...prev, qty: value }));
      return;
    }

    setMangoFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // When weight is selected, get the dimension and price details
    if (field === "weightId" && value) {
      // Use filtered weights to find the selected weight
      const filteredWeights = getFilteredFruitsWeightsForMango();
      const selectedWeight =
        filteredWeights.find((w) => w.id === parseInt(value)) ||
        fruitsWeights.find((w) => w.id === parseInt(value)); // Fallback to all weights if not found in filtered
      if (selectedWeight) {
        const dimension = dimensions.find(
          (d) => d.id === selectedWeight.dimensionId,
        );
        setSelectedWeightData({
          weight: selectedWeight,
          dimension: dimension,
          cost: selectedWeight.cost,
          boxName: dimension?.dimensionName || "",
          dimensionDetails: dimension
            ? `${parseFloat(dimension.length).toFixed(0)} x ${parseFloat(
                dimension.width,
              ).toFixed(0)} x ${parseFloat(dimension.height).toFixed(0)}`
            : "",
        });
      } else {
        setSelectedWeightData(null);
      }
    } else if (field === "weightId" && !value) {
      setSelectedWeightData(null);
    }
  };

  // Get the selected measurement unit description for regular form
  const selectedMeasurementUnit = measurementUnits.find(
    (unit) => unit.id === parseInt(formData.measurementUnitId),
  );
  const dimensionUnit = selectedMeasurementUnit?.unitDescription || "cm";

  // Get the selected measurement unit description for mango form
  const selectedMangoMeasurementUnit = measurementUnits.find(
    (unit) => unit.id === parseInt(mangoFormData.measurementUnitId),
  );
  const mangoDimensionUnit =
    selectedMangoMeasurementUnit?.unitDescription || "cm";

  const getMangoBoxLabel = (weightItem) => {
    // Get dimension name from weight object first, then fallback to dimensions array
    const dimName =
      weightItem?.dimensionName ||
      weightItem?.DimensionName ||
      dimensions.find((d) => d.id === weightItem?.dimensionId)?.dimensionName ||
      dimensions.find((d) => d.id === weightItem?.dimensionId)?.DimensionName ||
      "";

    //old weight range
    // const weightRange = `${parseFloat(weightItem?.minimumWeight || 0).toFixed(
    //   2,
    // )} - ${parseFloat(weightItem?.maximumWeight || 0).toFixed(2)} kg`;

    //new weight range
    const weightRange = weightItem?.weightDescription || "";

    // Show dimension name with weight range on the right
    return dimName ? `${dimName} (${weightRange})` : weightRange;
  };

  const scrollToContactUs = () => {
    const el = document.getElementById("contact-us");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    // Fallback if the section isn't mounted yet
    window.location.hash = "#contact-us";
  };

  const getMangoQty = () => {
    const parsed = parseInt(mangoFormData.qty, 10);
    const qty = Number.isFinite(parsed) ? parsed : 1;
    return Math.min(5, Math.max(1, qty));
  };

  const getMangoUnitPrice = (data = quotationData) => {
    if (data?.unitCost !== undefined || data?.UnitCost !== undefined) {
      return parseFloat(data.unitCost ?? data.UnitCost ?? 0);
    }
    if (data && (data.cost !== undefined || data.Cost !== undefined)) {
      return parseFloat(data.cost || data.Cost || 0);
    }
    if (selectedWeightData?.cost) {
      return parseFloat(selectedWeightData.cost || 0);
    }
    return 0;
  };

  const getMangoTotalPrice = (data = quotationData) => {
    if (data?.totalCost !== undefined || data?.TotalCost !== undefined) {
      return parseFloat(data.totalCost ?? data.TotalCost ?? 0);
    }
    return getMangoUnitPrice(data) * getMangoQty();
  };

  // Filter fruits weights by selected route for mango pricing
  const getFilteredFruitsWeightsForMango = () => {
    if (!fruitsWeights || fruitsWeights.length === 0) return [];

    console.log("Khalid fruitsWeights", fruitsWeights);
    console.log("Khalid mangoFormData", mangoFormData);

    // Filter by route if route is selected in mango form
    if (mangoFormData.routeId) {
      return fruitsWeights.filter(
        (w) => w.routeId === parseInt(mangoFormData.routeId),
      );
    }

    // If no route selected, return all fruit weights
    return fruitsWeights;
  };

  const updateMangoReceiver = (fields) => {
    setMangoReceiver((prev) => ({ ...prev, ...fields }));
  };

  const openMangoBookingModal = () => {
    if (!mangoFeatureEnabled) return;

    const draft = readMangoPricingDraft();
    if (!draft) {
      toast.error("Please get a mango price quotation first.");
      return;
    }
    setMangoReceiver((prev) => ({
      ...prev,
      receiverPostCode: (
        draft.toPostCode ||
        prev.receiverPostCode ||
        ""
      ).toUpperCase(),
    }));
    setMangoBookingModalOpen(true);
  };

  useEffect(() => {
    if (!mangoFeatureEnabled) return;
    if (searchParams.get("openMangoBooking") !== "1") return;
    if (!readMangoPricingDraft()) return;
    openMangoBookingModal();
    setSearchParams({}, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mangoFeatureEnabled, searchParams]);

  useEffect(() => {
    if (!mangoBookingModalOpen) return;
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    setMangoBookingFormData((prev) => ({
      ...prev,
      country: countries.length ? countries : prev.country,
    }));

    axios
      .get(`${backendUrl}city`, { headers })
      .then((res) => {
        setMangoBookingFormData((prev) => ({
          ...prev,
          country: countries.length ? countries : prev.country,
          city: res.data || [],
        }));
      })
      .catch((err) => console.log("Error fetching cities:", err.message));
  }, [mangoBookingModalOpen, countries, backendUrl]);

  const validateMangoReceiverOnLanding = async () => {
    const { receiverPostCode, receiverCountry } = mangoReceiver;
    const countryList = mangoBookingFormData.country?.length
      ? mangoBookingFormData.country
      : countries;

    const selectedCountry = countryList?.find(
      (c) => String(c.id) === String(receiverCountry),
    );
    const countryName = selectedCountry?.name?.toLowerCase() || "";

    const isUK =
      receiverCountry === "22" ||
      receiverCountry === 22 ||
      countryName === "uk";

    const isBangladesh =
      countryName.includes("bangladesh") || countryName === "bd";

    const requiresPostCode = isUK || isBangladesh;

    if (requiresPostCode && !receiverPostCode?.trim()) {
      toast.error("Please enter a post code.");
      return false;
    }

    if (requiresPostCode && receiverPostCode) {
      try {
        const validation = await validateAndFormatPostCodeFromWeb(
          receiverPostCode.trim(),
          receiverCountry,
          countryList || [],
        );
        if (!validation.isValid) {
          toast.error(`Invalid post code: ${validation.error}`);
          return false;
        }
        if (validation.formatted !== receiverPostCode.trim()) {
          updateMangoReceiver({ receiverPostCode: validation.formatted });
        }
      } catch (error) {
        const formatValidation = validatePostCode(
          receiverPostCode.trim(),
          receiverCountry,
          countryList || [],
        );
        if (!formatValidation.isValid) {
          toast.error(`Invalid post code: ${formatValidation.error}`);
          return false;
        }
      }
    }

    return true;
  };

  const handleMangoBookingContinue = async () => {
    if (
      !mangoReceiver.receiverName?.trim() ||
      !mangoReceiver.receiverEmail?.trim()
    ) {
      toast.error("Please complete receiver name and email.");
      return;
    }
    if (!mangoReceiver.receiverMobileNumber?.trim()) {
      toast.error("Please enter receiver mobile number.");
      return;
    }
    if (!mangoReceiver.receiverCountry || !mangoReceiver.receiverCity) {
      toast.error("Please select receiver country and city.");
      return;
    }
    if (!mangoReceiver.receiverAddress?.trim()) {
      toast.error("Please enter receiver address.");
      return;
    }
    if (!String(mangoReceiver.additionalInfo || "").trim()) {
      toast.error("Please add a note about your parcel.");
      return;
    }

    const draft = readMangoPricingDraft();
    if (!draft) {
      toast.error("Mango quotation not found. Please get pricing again.");
      return;
    }

    setMangoBookingSubmitting(true);
    try {
      const receiverOk = await validateMangoReceiverOnLanding();
      if (!receiverOk) return;

      const producDetails = buildMangoProducDetails(
        draft,
        fruitsWeights,
        dimensions,
      );
      const results = await fetchMangoTransitionCost(
        draft.routeId,
        producDetails,
      );
      summarizeTransitCostResults(results);

      const updatedDraft = mergeReceiverIntoDraft(
        draft,
        mangoReceiver,
        mangoReceiver.additionalInfo,
      );
      localStorage.setItem(PRICING_DRAFT_KEY, JSON.stringify(updatedDraft));
      saveMangoTransitCost(results);
      markMangoShipmentReady();

      setMangoBookingModalOpen(false);
      setQuotationData(null);
      navigate("/mango-booking");
    } catch (err) {
      if (err?.message === "INCOMPLETE_PARCEL") {
        toast.error("Please complete parcel product details.");
      } else {
        toast.error("Failed to calculate shipping cost.");
        console.log(err);
      }
    } finally {
      setMangoBookingSubmitting(false);
    }
  };

  const handleBookNow = () => {
    const token = localStorage.getItem("token");
    if (isMangoPricing) {
      if (!token) {
        localStorage.setItem("sundorbonPricingDraftKeep", "1");
        redirectToIdentityLogin(
          `${window.location.origin}/?openMangoBooking=1`,
        );
        return;
      }
      openMangoBookingModal();
      return;
    }
    if (!token) {
      redirectToIdentityLogin(`${window.location.origin}/bookings`);
      return;
    }
    navigate("/bookings");
  };

  const handleGetQuotation = async (e, isMango = false) => {
    e.preventDefault();

    // Validation
    if (isMango) {
      if (!mangoFormData.toPostCode) {
        toast.error("Please enter to post code", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      if (!mangoFormData.routeId) {
        toast.error("Please select a route", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      if (!mangoFormData.routeId) {
        toast.error("Please select a route", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      if (!mangoFormData.weightId) {
        toast.error("Please select a box", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      const mangoQty = parseInt(mangoFormData.qty, 10);
      if (!mangoQty || mangoQty < 1) {
        toast.error("Please enter quantity.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      if (mangoQty > 5) {
        toast.error("For more than 5 boxes, please contact us.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        scrollToContactUs();
        return;
      }

      // Validate UK postcode for mango pricing before proceeding
      try {
        const postCodeValue = mangoFormData.toPostCode.trim();
        if (postCodeValue) {
          // Mango pricing is always UK (id 22)
          const validation = await validateAndFormatPostCodeFromWeb(
            postCodeValue,
            22,
            countries,
          );
          if (!validation.isValid) {
            setMangoPostCodeError(validation.error);
            return; // Don't proceed with API call if postcode is invalid
          }

          // Clear error if valid
          setMangoPostCodeError("");

          // If validation succeeded, update formatted version if different
          if (validation.data && validation.formatted !== postCodeValue) {
            handleMangoInputChange("toPostCode", validation.formatted);
          }
        } else {
          setMangoPostCodeError("");
        }
      } catch (error) {
        console.error("Post code validation error:", error);
        setMangoPostCodeError(
          "Failed to validate post code. Please check your connection and try again.",
        );
        return; // Don't proceed if validation fails
      }
    } else {
      if (!formData.routeId) {
        toast.error("Please select a route", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      if (!formData.measurementUnitId) {
        toast.error("Please select a measurement unit", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      if (!formData.fromPostCode || !formData.toPostCode) {
        toast.error("Please enter from and to post code", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      if (
        !formData.weight ||
        !formData.length ||
        !formData.width ||
        !formData.height
      ) {
        toast.error("Please fill in all dimensions and weight", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
    }

    setLoading(true);
    try {
      let requestData;

      if (isMango) {
        // Mango Pricing - validate weight selection
        if (!mangoFormData.weightId) {
          toast.error("Please select a box", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setLoading(false);
          return;
        }
        const mangoQtyCheck = parseInt(mangoFormData.qty, 10);
        if (!mangoQtyCheck || mangoQtyCheck < 1) {
          toast.error("Please enter quantity.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setLoading(false);
          return;
        }
        if (mangoQtyCheck > 5) {
          toast.error("For more than 5 boxes, please contact us.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          scrollToContactUs();
          setLoading(false);
          return;
        }
        // Request data will be set in the API call section below
      } else {
        // Regular Pricing
        const routeId = parseInt(formData.routeId);
        const measurementUnitId = parseInt(formData.measurementUnitId);
        const weight = parseFloat(formData.weight);
        const length = parseFloat(formData.length);
        const width = parseFloat(formData.width);
        const height = parseFloat(formData.height);

        // Calculate volume: length × width × height
        const volume = length * width * height;

        requestData = {
          routeId: routeId,
          measurementUnitId: measurementUnitId,
          fromPostCode: (formData.fromPostCode || "").toUpperCase(),
          toPostCode: (formData.toPostCode || "").toUpperCase(),
          weight: weight,
          volume: volume,
          length: length,
          width: width,
          height: height,
          quotationType: "Regular",
        };
      }

      // Call appropriate API endpoint based on pricing type
      const token = localStorage.getItem("token");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      let apiEndpoint;
      if (isMango) {
        // Use new Mango Pricing API
        apiEndpoint = `${backendUrl}Quotation/GetMangoPricing`;
        const clampedQty = getMangoQty();
        requestData = {
          routeId: parseInt(mangoFormData.routeId),
          weightId: parseInt(mangoFormData.weightId),
          toPostCode: (mangoFormData.toPostCode || "").toUpperCase(),
          qty: clampedQty,
        };
      } else {
        // Use regular Pricing API
        apiEndpoint = `${backendUrl}Quotation/GetPricing`;
      }

      const response = await axios.post(apiEndpoint, requestData, { headers });

      // Handle response from API (works for both GetPricing and GetMangoPricing)
      // Check for both IsSuccess (PascalCase) and isSuccess (camelCase)
      const isSuccess =
        response.data?.IsSuccess === 1 || response.data?.isSuccess === 1;

      if (response.data && isSuccess) {
        // Success - set quotation data
        // For mango pricing, map BoxName to DimensionName if needed
        if (isMango && response.data.BoxName && !response.data.DimensionName) {
          response.data.DimensionName = response.data.BoxName;
        }
        if (isMango) {
          const mangoQty = getMangoQty();
          const unitCost = parseFloat(
            response.data.cost ?? response.data.Cost ?? 0,
          );
          response.data.unitCost = unitCost;
          response.data.mangoQty = mangoQty;
          response.data.totalCost = unitCost * mangoQty;
        }
        setQuotationData(response.data);
        setIsMangoPricing(isMango); // Track if this is mango pricing
        console.log("Quotation Response:", response.data);

        // Persist draft for booking prefill
        try {
          const fromPostCode = isMango
            ? ""
            : (formData.fromPostCode || "").toUpperCase();
          const toPostCode = (
            (isMango ? mangoFormData.toPostCode : formData.toPostCode) || ""
          ).toUpperCase();

          // Sender info for mango pricing
          const senderInfo = isMango
            ? {
                senderName: "Sundarban Cargo Service",
                senderEmail: "admin@sundarbancargoservicesltd.uk",
                senderMobileNumber: "+03338802489",
                senderAddress: "9 Village Green Road, Crayford, DA1 4JX",
                senderPostCode: "DA1 4JX",
                // Country and City will be resolved in Bookings component using name matching
                senderCountryName: "UK",
                senderCityName: "London",
              }
            : null;

          const draft = {
            createdAt: new Date().toISOString(),
            pricingType: isMango ? "mango" : "regular",
            routeId: parseInt(
              isMango ? mangoFormData.routeId : formData.routeId,
            ),
            fromPostCode,
            toPostCode,
            senderInfo, // Include sender info for mango pricing
            parcel: isMango
              ? {
                  weight: (() => {
                    const minW = Number(
                      response.data?.minimumWeight ??
                        response.data?.MinimumWeight,
                    );
                    const maxW = Number(
                      response.data?.maximumWeight ??
                        response.data?.MaximumWeight,
                    );
                    if (Number.isFinite(minW) && Number.isFinite(maxW))
                      return minW; // default to min
                    return "";
                  })(),
                  length: response.data?.length ?? response.data?.Length ?? "",
                  width: response.data?.width ?? response.data?.Width ?? "",
                  height: response.data?.height ?? response.data?.Height ?? "",
                  preset: "",
                }
              : {
                  weight: formData.weight,
                  length: formData.length,
                  width: formData.width,
                  height: formData.height,
                  preset: "",
                },
            mango: isMango
              ? {
                  weightId: parseInt(mangoFormData.weightId),
                  qty: getMangoQty(),
                  unitCost: parseFloat(
                    response.data?.unitCost ??
                      response.data?.cost ??
                      response.data?.Cost ??
                      0,
                  ),
                  totalCost: parseFloat(
                    response.data?.totalCost ??
                      (response.data?.unitCost ??
                        response.data?.cost ??
                        response.data?.Cost ??
                        0) * getMangoQty(),
                  ),
                  dimensionId:
                    response.data?.dimensionId ??
                    response.data?.DimensionId ??
                    null,
                  dimensionName:
                    response.data?.dimensionName ??
                    response.data?.DimensionName ??
                    "",
                  unitDescription:
                    response.data?.unitDescription ??
                    response.data?.UnitDescription ??
                    "",
                }
              : null,
          };
          localStorage.setItem(PRICING_DRAFT_KEY, JSON.stringify(draft));
        } catch (err) {
          console.log("Failed to store pricing draft:", err?.message || err);
        }
      } else {
        // Error from stored procedure
        const errorMessage =
          response.data?.Message ||
          response.data?.message ||
          "Failed to get price. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setQuotationData(null);
        setIsMangoPricing(false);
      }
    } catch (error) {
      console.error("Error getting quotation:", error);
      const errorMessage =
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message ||
        "Failed to get price. Please try again.";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setQuotationData(null);
      setIsMangoPricing(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="quotation-section" id="get-shipping-price">
      <ToastContainer />

      {/* Get Your Shipping Price Section with Tabs */}
      <div className="pricing-bg-section py-10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          {/* Two Column Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_1fr] gap-10 items-start">
            {/* Left Column */}
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-center mb-6 text-gray-800">
                Get Shipping Price
              </h2>

              <div className="bg-white rounded-lg shadow-xl p-4 lg:p-6 max-w-6xl mx-auto">
                {/* Tabs */}
                <div className="flex flex-row gap-2 mb-6 border-b-2 border-gray-200">
                  <button
                    type="button"
                    onClick={() => setActiveTab("regular")}
                    className={`px-6 py-3 font-semibold text-base rounded-t-lg transition-all duration-300 ${
                      activeTab === "regular"
                        ? "bg-orange-500 text-white shadow-lg"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                  >
                    All Item Pricing
                  </button>
                  {mangoFeatureEnabled ? (
                    <button
                      type="button"
                      onClick={() => setActiveTab("mango")}
                      className={`px-6 py-3 font-semibold text-base rounded-t-lg transition-all duration-300 ${
                        activeTab === "mango"
                          ? "bg-orange-500 text-white shadow-lg"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                      }`}
                    >
                      Mango Pricing
                    </button>
                  ) : null}
                </div>

                {/* Tab Content */}
                {activeTab === "regular" ? (
                  <form
                    onSubmit={(e) => handleGetQuotation(e, false)}
                    className="space-y-4"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Route and Measurement Unit in same row */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Select Route <span className="text-red-500">*</span>
                        </label>
                        <DropDown
                          required={true}
                          alltimeValue={formData.routeId}
                          valueUpdate={(e) =>
                            handleInputChange("routeId", e.target.value)
                          }
                          placeHolder="Select a route"
                        >
                          {routes.map((item) => (
                            <option value={item.id} key={item.id}>
                              {item.routeName}
                            </option>
                          ))}
                        </DropDown>
                      </div>
                      {/* Measurement Unit Dropdown */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Measurement Unit{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <DropDown
                          required={true}
                          alltimeValue={formData.measurementUnitId}
                          valueUpdate={(e) =>
                            handleInputChange(
                              "measurementUnitId",
                              e.target.value,
                            )
                          }
                          placeHolder="Select measurement unit"
                        >
                          {measurementUnits.map((item) => (
                            <option value={item.id} key={item.id}>
                              {item.unitDescription}
                            </option>
                          ))}
                        </DropDown>
                      </div>
                    </div>

                    {/* From/To Post Code */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          From Post Code <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          required
                          value={formData.fromPostCode}
                          onChange={(e) =>
                            handleInputChange(
                              "fromPostCode",
                              e.target.value.toUpperCase(),
                            )
                          }
                          placeholder="e.g. LA 2AK"
                          className="w-full border border-gray-400 h-12 px-4 outline-none rounded-sm focus:border-[#83430D] focus:ring-2 focus:ring-[#83430D]/20 text-base"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          To Post Code <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          required
                          value={formData.toPostCode}
                          onChange={(e) =>
                            handleInputChange(
                              "toPostCode",
                              e.target.value.toUpperCase(),
                            )
                          }
                          placeholder="e.g. SAN A4ND"
                          className="w-full border border-gray-400 h-12 px-4 outline-none rounded-sm focus:border-[#83430D] focus:ring-2 focus:ring-[#83430D]/20 text-base"
                        />
                      </div>
                    </div>

                    {/* Weight and Dimensions - Horizontal Layout */}
                    <div className="md:col-span-2">
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        {/* Weight Input */}
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Weight <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              step="0.01"
                              required
                              value={formData.weight}
                              onChange={(e) =>
                                handleInputChange("weight", e.target.value)
                              }
                              placeholder="Enter weight"
                              className="w-full border border-gray-400 h-12 px-4 pr-12 outline-none rounded-sm focus:border-[#83430D] focus:ring-2 focus:ring-[#83430D]/20 text-base"
                            />
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
                              kg
                            </span>
                          </div>
                        </div>
                        {/* Length Input */}
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Length <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              step="0.01"
                              required
                              value={formData.length}
                              onChange={(e) =>
                                handleInputChange("length", e.target.value)
                              }
                              placeholder="Enter length"
                              className="w-full border border-gray-400 h-12 px-4 pr-12 outline-none rounded-sm focus:border-[#83430D] focus:ring-2 focus:ring-[#83430D]/20 text-base"
                            />
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
                              {dimensionUnit}
                            </span>
                          </div>
                        </div>
                        {/* Width Input */}
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Width <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              step="0.01"
                              required
                              value={formData.width}
                              onChange={(e) =>
                                handleInputChange("width", e.target.value)
                              }
                              placeholder="Enter width"
                              className="w-full border border-gray-400 h-12 px-4 pr-12 outline-none rounded-sm focus:border-[#83430D] focus:ring-2 focus:ring-[#83430D]/20 text-base"
                            />
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
                              {dimensionUnit}
                            </span>
                          </div>
                        </div>

                        {/* Height Input */}
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Height <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              step="0.01"
                              required
                              value={formData.height}
                              onChange={(e) =>
                                handleInputChange("height", e.target.value)
                              }
                              placeholder="Enter height"
                              className="w-full border border-gray-400 h-12 px-4 pr-12 outline-none rounded-sm focus:border-[#83430D] focus:ring-2 focus:ring-[#83430D]/20 text-base"
                            />
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
                              {dimensionUnit}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Get Quotation Button */}
                    <div className="flex justify-center pt-2">
                      <button
                        type="submit"
                        disabled={loading}
                        className=" relative rounded-md overflow-hidden bg-orange-500 px-5 py-3 text-white font-semibold ml-5
    transition-all duration-300 ease-in-out
    hover:bg-orange-600
    before:absolute before:top-0 before:left-[-75%] before:w-1/2 before:h-full
    before:bg-white before:opacity-20 before:transform before:rotate-12
    before:transition-all before:duration-500
    hover:before:left-[125%]"
                      >
                        {loading ? "Getting Price..." : "GET PRICING"}
                      </button>
                    </div>
                  </form>
                ) : (
                  <form
                    onSubmit={(e) => handleGetQuotation(e, true)}
                    className="space-y-4"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Select Route <span className="text-red-500">*</span>
                        </label>
                        <DropDown
                          required={true}
                          alltimeValue={mangoFormData.routeId}
                          valueUpdate={(e) =>
                            handleMangoInputChange("routeId", e.target.value)
                          }
                          placeHolder="Select a route"
                          disabled={true}
                        >
                          {routes.map((item) => (
                            <option value={item.id} key={item.id}>
                              {item.routeName}
                            </option>
                          ))}
                        </DropDown>
                      </div>
                      {/* Box Dropdown - Aligned with Route */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Select Box <span className="text-red-500">*</span>
                        </label>
                        <DropDown
                          required={true}
                          alltimeValue={mangoFormData.weightId}
                          valueUpdate={(e) =>
                            handleMangoInputChange("weightId", e.target.value)
                          }
                          placeHolder="Select box"
                        >
                          {getFilteredFruitsWeightsForMango().map((item) => (
                            <option value={item.id} key={item.id}>
                              {getMangoBoxLabel(item)}
                            </option>
                          ))}
                        </DropDown>
                        <p className="text-xs text-gray-500 mt-2">
                          If you don&apos;t find the box size in the select box
                          drop down{" "}
                          <button
                            type="button"
                            onClick={scrollToContactUs}
                            className="text-orange-600 font-semibold hover:underline"
                          >
                            Contact us
                          </button>
                          .
                        </p>
                      </div>
                    </div>
                    {/* To Post Code */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          To Post Code <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          required
                          value={mangoFormData.toPostCode}
                          onChange={(e) => {
                            handleMangoInputChange(
                              "toPostCode",
                              e.target.value.toUpperCase(),
                            );
                            // Clear error when user starts typing
                            if (mangoPostCodeError) {
                              setMangoPostCodeError("");
                            }
                          }}
                          onBlur={async (e) => {
                            const value = e.target.value.trim();
                            if (value) {
                              // Mango pricing is always UK (id 22)
                              try {
                                // Use web API validation
                                const validation =
                                  await validateAndFormatPostCodeFromWeb(
                                    value,
                                    22,
                                    countries,
                                  );
                                if (!validation.isValid) {
                                  setMangoPostCodeError(validation.error);
                                } else {
                                  setMangoPostCodeError("");
                                  if (validation.formatted !== value) {
                                    handleMangoInputChange(
                                      "toPostCode",
                                      validation.formatted,
                                    );
                                  }
                                }
                              } catch (error) {
                                console.error(
                                  "Post code validation error:",
                                  error,
                                );
                                // Fallback to format validation
                                const formatValidation = validatePostCode(
                                  value,
                                  22,
                                  countries,
                                );
                                if (!formatValidation.isValid) {
                                  setMangoPostCodeError(formatValidation.error);
                                } else {
                                  setMangoPostCodeError("");
                                }
                              }
                            } else {
                              setMangoPostCodeError("");
                            }
                          }}
                          placeholder="e.g. E1 6AN"
                          className={`w-full border h-12 px-4 outline-none rounded-sm focus:ring-2 focus:ring-[#83430D]/20 text-base ${
                            mangoPostCodeError
                              ? "border-red-500 focus:border-red-500"
                              : "border-gray-400 focus:border-[#83430D]"
                          }`}
                        />
                        {mangoPostCodeError && (
                          <p className="text-red-500 text-sm mt-1">
                            {mangoPostCodeError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Qty <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          required
                          min={1}
                          max={1}
                          step={1}
                          value={mangoFormData.qty}
                          onChange={(e) =>
                            handleMangoInputChange("qty", e.target.value)
                          }
                          onBlur={() => {
                            const q = parseInt(mangoFormData.qty, 10);
                            if (!q || q < 1) {
                              handleMangoInputChange("qty", "1");
                              return;
                            }
                            if (q > 1) {
                              toast.error(
                                "For more than 1 box, please contact us.",
                              );
                              scrollToContactUs();
                              handleMangoInputChange("qty", "1fix:");
                            }
                          }}
                          placeholder="1"
                          className="w-full border h-12 px-4 outline-none rounded-sm border-gray-400 focus:border-[#83430D] focus:ring-2 focus:ring-[#83430D]/20 text-base"
                        />
                        <p className="text-xs text-gray-500 mt-2">
                          Want to buy more than 1 box?{" "}
                          <button
                            type="button"
                            onClick={scrollToContactUs}
                            className="text-orange-600 font-semibold hover:underline"
                          >
                            Contact us
                          </button>
                          .
                        </p>
                      </div>
                    </div>

                    {/* Submit */}
                    <div className="flex justify-center pt-2">
                      <button
                        type="submit"
                        disabled={loading}
                        className="relative overflow-hidden rounded-md bg-orange-500 px-5 py-3 text-white font-semibold ml-5
    transition-all duration-300 ease-in-out
    hover:bg-orange-600
    before:absolute before:top-0 before:left-[-75%] before:w-1/2 before:h-full
    before:bg-white before:opacity-20 before:transform before:rotate-12
    before:transition-all before:duration-500
    hover:before:left-[125%]"
                      >
                        {loading ? "Getting Price..." : "GET PRICING"}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>

            {/* ================= RIGHT COLUMN ================= */}
            <div
              className={`
    relative
    ${
      activeTab === "mango"
        ? "h-[300px] sm:h-[340px] lg:h-[372px]"
        : "h-[360px] sm:h-[400px] lg:h-[463px]"
    }
    overflow-hidden
    rounded-md
    bg-cover bg-center
    mt-6 ${activeTab === "mango" ? "lg:mt-[64px]" : "lg:mt-[64px]"}
    transition-all duration-700 ease-in-out
  `}
              style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
            >
              {/* Dark overlay */}
              <div className="absolute inset-0 bg-black/50 z-10" />

              {/* Orange decorative curve */}
              <div
                className="
      absolute
      top-0
      right-[-160px] sm:right-[-120px]
      h-full
      w-[200px] sm:w-[240px]
      bg-[#df973ac0]
      rounded-full
      z-20
    "
              />

              {/* Content */}
              <div
                className="
      relative z-30
      px-4 sm:px-6 lg:px-8
      py-6 sm:py-8 lg:py-10
      h-full
      flex flex-col
      justify-between
    "
              >
                {/* Heading */}
                <h2
                  className="
    text-xl sm:text-2xl lg:text-4xl
    font-extrabold
    text-white
    max-w-xs sm:max-w-sm lg:max-w-md
    drop-shadow-lg
    leading-tight
  "
                >
                  {slides[currentSlide].title}
                </h2>

                {/* Bottom row */}
                <div
                  className="
        flex
        flex-col sm:flex-row
        gap-4 sm:gap-0
        sm:items-center
        sm:justify-between
      "
                >
                  <Link
                    to="/bookings"
                    className="
          group
          inline-flex
          items-center
          justify-center
          gap-3
          bg-white
          text-[#0e0a73]
          font-bold
          px-5 sm:px-6
          py-3
          rounded-xl
          shadow-md
          w-full sm:w-auto
        "
                  >
                    Book Now
                    <Icon
                      className="inline-block transform transition-transform duration-300 group-hover:translate-x-2"
                      icon="flowbite:arrow-right-outline"
                      width="24"
                    />
                  </Link>

                  {/* Carousel indicators */}
                  <div className="flex justify-center sm:justify-end gap-2">
                    {slides.map((_, index) => (
                      <span
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`
        w-2.5 h-2.5 rounded-full shadow-md cursor-pointer                             
        transition-all duration-300
        ${
          currentSlide === index
            ? "bg-white scale-110"
            : "bg-white/40 hover:bg-white/70"
        }
      `}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Display Quotation Result in Modal */}
      <Dialog
        open={
          quotationData &&
          (quotationData.IsSuccess === 1 || quotationData.isSuccess === 1)
            ? true
            : false
        }
        onClose={() => {
          setQuotationData(null);
          setIsMangoPricing(false);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent style={{ padding: 0 }}>
          <div className="relative">
            {/* Close Icon */}
            <IconButton
              aria-label="close"
              onClick={() => setQuotationData(null)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
                zIndex: 1,
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Modal Content */}
            <div className="p-6 bg-gradient-to-br from-green-50 to-blue-50">
              <h3 className="text-2xl font-bold text-green-800 mb-4">
                Your Shipping Price
              </h3>

              {isMangoPricing ? (
                /* Mango Pricing Display: Route Name, Weight, Dimension Name, Price */
                <div className="bg-white p-4 rounded-lg shadow mb-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                    {/* Route Name */}
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Route Name</p>
                      <p className="text-sm font-semibold text-gray-800">
                        {quotationData && quotationData.routeId
                          ? routes.find((r) => r.id === quotationData.routeId)
                              ?.routeName || "N/A"
                          : "N/A"}
                      </p>
                    </div>

                    {/* Weight */}
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Weight</p>
                      <p className="text-sm font-semibold text-gray-800">
                        {selectedWeightData &&
                        selectedWeightData.weight &&
                        selectedWeightData.weight.weightDescription
                          ? selectedWeightData.weight.weightDescription
                          : selectedWeightData && selectedWeightData.weight
                            ? `${parseFloat(
                                selectedWeightData.weight.minimumWeight || 0,
                              ).toFixed(2)} - ${parseFloat(
                                selectedWeightData.weight.maximumWeight || 0,
                              ).toFixed(2)} kg`
                            : fruitsWeights.find(
                                (w) =>
                                  w.id === parseInt(mangoFormData.weightId),
                              )?.weightDescription || "N/A"}
                      </p>
                    </div>

                    {/* Dimension Name with Dimensions (Length x Height x Width) */}
                    <div>
                      <p className="text-xs text-gray-600 mb-1">
                        Dimension Name
                      </p>
                      <p className="text-sm font-semibold text-gray-800">
                        {(() => {
                          // Get dimension name
                          const dimName =
                            quotationData &&
                            (quotationData.dimensionName ||
                              quotationData.DimensionName)
                              ? quotationData.dimensionName ||
                                quotationData.DimensionName
                              : selectedWeightData && selectedWeightData.boxName
                                ? selectedWeightData.boxName
                                : null;

                          // Get dimensions
                          const dim =
                            selectedWeightData && selectedWeightData.dimension;

                          // Get measurement unit name
                          let unitName = "";
                          if (
                            quotationData &&
                            (quotationData.unitDescription ||
                              quotationData.UnitDescription)
                          ) {
                            unitName =
                              quotationData.unitDescription ||
                              quotationData.UnitDescription;
                          } else if (dim && dim.measurementUnitId) {
                            const unit = measurementUnits.find(
                              (u) => u.id === dim.measurementUnitId,
                            );
                            unitName = unit ? unit.unitDescription : "";
                          }

                          if (!dimName) return "N/A";

                          return (
                            <>
                              {dimName}
                              {dim && (
                                <span className="text-gray-600 font-normal">
                                  {" "}
                                  ({parseFloat(dim.length || 0).toFixed(
                                    0,
                                  )} x {parseFloat(dim.height || 0).toFixed(0)}{" "}
                                  x {parseFloat(dim.width || 0).toFixed(0)})
                                  {unitName && ` ${unitName}`}
                                </span>
                              )}
                            </>
                          );
                        })()}
                      </p>
                    </div>

                    {/* Qty */}
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Qty</p>
                      <p className="text-sm font-semibold text-gray-800">
                        {quotationData?.mangoQty ?? getMangoQty()}
                      </p>
                    </div>

                    {/* Price (unit × qty) */}
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Price</p>
                      <p className="text-lg font-bold text-green-600">
                        £{getMangoTotalPrice().toFixed(2)}
                      </p>
                      <p className="text-xs text-gray-500 mt-0.5">
                        £{getMangoUnitPrice().toFixed(2)} ×{" "}
                        {quotationData?.mangoQty ?? getMangoQty()}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                /* Regular Pricing Display */
                <>
                  {/* Display Input Details */}
                  <div className="bg-white p-4 rounded-lg shadow mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">
                      Your Input Details
                    </h4>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                      {/* Selected Route */}
                      <div>
                        <p className="text-xs text-gray-600 mb-1">Route</p>
                        <p className="text-sm font-semibold text-gray-800">
                          {quotationData && quotationData.routeId
                            ? routes.find((r) => r.id === quotationData.routeId)
                                ?.routeName || "N/A"
                            : "N/A"}
                        </p>
                      </div>

                      {/* Weight */}
                      <div>
                        <p className="text-xs text-gray-600 mb-1">Weight</p>
                        <p className="text-sm font-semibold text-gray-800">
                          {formData.weight
                            ? `${parseFloat(formData.weight || 0).toFixed(
                                2,
                              )} kg`
                            : quotationData && quotationData.weight
                              ? `${parseFloat(
                                  quotationData.weight || 0,
                                ).toFixed(2)} kg`
                              : "N/A"}
                        </p>
                      </div>

                      {/* Length */}
                      <div>
                        <p className="text-xs text-gray-600 mb-1">Length</p>
                        <p className="text-sm font-semibold text-gray-800">
                          {formData.length
                            ? `${parseFloat(formData.length || 0).toFixed(
                                2,
                              )} ${dimensionUnit}`
                            : quotationData && quotationData.length
                              ? `${parseFloat(
                                  quotationData.length || 0,
                                ).toFixed(
                                  2,
                                )} ${quotationData.unitDescription || ""}`
                              : "N/A"}
                        </p>
                      </div>

                      {/* Width */}
                      <div>
                        <p className="text-xs text-gray-600 mb-1">Width</p>
                        <p className="text-sm font-semibold text-gray-800">
                          {formData.width
                            ? `${parseFloat(formData.width || 0).toFixed(
                                2,
                              )} ${dimensionUnit}`
                            : quotationData && quotationData.width
                              ? `${parseFloat(quotationData.width || 0).toFixed(
                                  2,
                                )} ${quotationData.unitDescription || ""}`
                              : "N/A"}
                        </p>
                      </div>

                      {/* Height */}
                      <div>
                        <p className="text-xs text-gray-600 mb-1">Height</p>
                        <p className="text-sm font-semibold text-gray-800">
                          {formData.height
                            ? `${parseFloat(formData.height || 0).toFixed(
                                2,
                              )} ${dimensionUnit}`
                            : quotationData && quotationData.height
                              ? `${parseFloat(
                                  quotationData.height || 0,
                                ).toFixed(
                                  2,
                                )} ${quotationData.unitDescription || ""}`
                              : "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Display Cost - Main Focus */}
                  {quotationData &&
                    (quotationData.cost !== undefined ||
                      quotationData.Cost !== undefined) && (
                      <div className="bg-white p-6 rounded-lg shadow-lg mb-4">
                        <p className="text-sm text-gray-600 mb-2">
                          Shipping Cost
                        </p>
                        <p className="text-4xl font-bold text-green-600">
                          £
                          {parseFloat(
                            quotationData.cost || quotationData.Cost || 0,
                          ).toFixed(2)}
                        </p>
                      </div>
                    )}
                </>
              )}

              {/* Book Now */}
              <div className="flex justify-center pt-4">
                {isMangoPricing ? (
                  <button
                    type="button"
                    onClick={handleBookNow}
                    className="relative overflow-hidden bg-orange-500 px-5 py-3 text-white font-semibold ml-5
        transition-all duration-300 ease-in-out
        hover:bg-orange-600
        before:absolute before:top-0 before:left-[-75%] before:w-1/2 before:h-full
        before:bg-white before:opacity-20 before:transform before:rotate-12
        before:transition-all before:duration-500
        hover:before:left-[125%]"
                  >
                    Book Now
                  </button>
                ) : (
                  <Link
                    to="/bookings"
                    className="relative overflow-hidden bg-orange-500 px-5 py-3 text-white font-semibold ml-5
        transition-all duration-300 ease-in-out
        hover:bg-orange-600
        before:absolute before:top-0 before:left-[-75%] before:w-1/2 before:h-full
        before:bg-white before:opacity-20 before:transform before:rotate-12
        before:transition-all before:duration-500
        hover:before:left-[125%]"
                  >
                    Book Now
                  </Link>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {mangoFeatureEnabled ? (
        <MangoBookingModal
          open={mangoBookingModalOpen}
          onClose={() => setMangoBookingModalOpen(false)}
          onContinue={handleMangoBookingContinue}
          loading={mangoBookingSubmitting}
          additionalInfo={mangoReceiver.additionalInfo}
          updateFields={updateMangoReceiver}
          fetchedFormData={mangoBookingFormData}
          receiverFormProps={{
            receiverName: mangoReceiver.receiverName,
            receiverEmail: mangoReceiver.receiverEmail,
            receiverMobileNumber: mangoReceiver.receiverMobileNumber,
            receiverCountry: mangoReceiver.receiverCountry,
            receiverLandmark: mangoReceiver.receiverLandmark,
            receiverCity: mangoReceiver.receiverCity,
            receiverDoorNo: mangoReceiver.receiverDoorNo,
            receiverStreetName: mangoReceiver.receiverStreetName,
            receiverRemarks: mangoReceiver.receiverRemarks,
            receiverAddress: mangoReceiver.receiverAddress,
            receiverPostCode: mangoReceiver.receiverPostCode,
          }}
        />
      ) : null}
    </div>
  );
};

export default Quotation;
